// Import Atoms
import Logo from "../../atoms/logo/Logo"
import ButtonComp from "../../atoms/button/Button"

// Import Molecule
import SidebarUserProfile from "../../molecules/sidebar/SidebarUserProfile";

// Import SidebarButtonsRoute
import SidebarButtonsRoute from "../../molecules/sidebar/SidebarButtonRoute";

// Imports MUI Components
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  Typography,
  Avatar,
  useMediaQuery,
} from "@mui/material"

import {
  Dashboard,
  Assignment,
  Inventory,
  MonetizationOn,
  Group,
  Settings, 
  ExitToApp,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";

import React, { useState } from "react";

const drawerWidth = 300;
const collapsedWidth = 80;


const Sidebar = ({ fName, lName, email}) => {

  const [open, setOpen] = useState(true);
  const isMobile = useMediaQuery("(max-width:768px)");

  const toggleDrawer = () => setOpen(!open);

  const drawerContent = (
    <Box
      sx={{
        // zIndex: 2,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflowX: "hidden",
      }}
    >
      {/* Logo (sticky top) */}
      <Box
        sx={{
          margin: 
            open ? "20px" : "20px 0",
          position: "sticky",
          top: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: 
            open ? "start" : "center",
          height: 70,
          backgroundColor: "transparent",
          transition: "margin 0.3s ease",
          // borderBottom: "1px solid #444",
        }}
      >
        
        <Logo 
          src={require('../../../../assets/logo.png')}
          destination="/#"
          />

      </Box>
        {isMobile &&
        <Divider sx={{ borderColor: "#555" }} />
      }

      {/* Navigation (scrollable middle) */}
      <Box 
        sx={{
          // scrollbar: "none",
          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",
          mt: 2,
          ml: open ? 3 : 1,
          mr: open ? 0 : 1
        }}
      >
        <List>
          {/* Sidebar Buttons */}
              <SidebarButtonsRoute
                open={open}/>
        </List>
      </Box>

      <Divider sx={{ borderColor: "#555" }} />

      {/* User profile (sticky bottom) */}
      <Box sx={{ p: 2, position: "sticky", bottom: 0, backgroundColor: "#2E2D2D", justifyItems: "center", }}>
        {/* Sidebar User Profile */}
            <SidebarUserProfile
              name={
                [fName, lName].filter(Boolean).join(" ").trim() || "Patient"
              }
              email={email || "No contact info"}
              open={open}/>
              
        {/* Sign Out Button */}
            <ButtonComp
              buttonId="signOut"
              variant="contained"
              noElevate={true}
              noRipple={true}
              label="Sign Out"
              color="light"
              paddings="medium"
              background="dark"
              selected={true}
              keys={false}
              font="default"
              weight="default"
              border="default"
              transform="default"
              hoverTextColor="light"
              hoverBackground="special"
              hoverBorder="default"
              noRead={false}
              iconned={true}
              source={require("../../../../assets/logout.png")}
              size="small"
              type="default"
              justify="special"
              open={open}/>
      </Box>
    </Box>
  );


  const stackStylesButtons = {
    padding: "10px 0",
    textAlign: "start",
    marginLeft: "20px",
    position: "fixed",
    // backgroundColor: "blue",
    "@media (max-width: 900px)": {
      textAlign: "center",
      marginLeft: "0",
      alignItems: "center",
    },
  }

  const stackStylesProfile = {
    margin: "25px 20px"
  }

  const displayStylesHide = {
    display: {
      xs: "none", 
      sm: "none", 
      md: "none", 
      lg: "none", 
      xl: "block" 
    },
  }

  const boxStylesWrapper = {
    backgroundColor: "#2E2D2D",
    height: "100vh",
    display: "flex",
    flexDirection: "column", 
    justifyContent: "space-between",
    "@media (max-width: 1200px)": {
      width: "100px", 
    },
    // width: {
    //   xs: "100px", 
    //   sm: "100px", 
    //   md: "100px", 
    //   lg: "100px", 
    //   xl: "100%", 
    // },
  }

  const boxStylesLogo = {
    margin: "10px"
  }

  const boxStylesProfile = {
    borderTop: "2px solid rgba(89, 84, 74, .2)"
  }

  return (
    <Box 
      sx={{ 
        display: "flex",
      }}>
      {/* Sidebar Drawer */}
      <Drawer
        variant="permanent"
        open={open}
        onClose={toggleDrawer}
        sx={{
          width: open ? drawerWidth : collapsedWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : collapsedWidth,
            boxSizing: "border-box",
            bgcolor: "#2E2C2C",
            color: "white",
            transition: "width 0.3s",
            overflowX: "hidden",
          },
        }}
      >
        {drawerContent}
        {/* Toggle button */}
        <IconButton
          onClick={toggleDrawer}
          sx={{
            display: {
              xs : "none",
              sm : "none",
              md : "flex",
              lg : "flex",
              xl : "flex", 
            },
            padding: 
              open ? 2 : 2,
            position: "absolute",
            top: "45%",
            right: -15,
            bgcolor: "#444",
            color: "white",
            "&:hover": { bgcolor: "#555" },
          }}
        >
          {open ? <ChevronLeft /> : <ChevronRight />}
        </IconButton>
      </Drawer>

    </Box>
  );
  
};

export default Sidebar;